export const en = {
  validate: {
    title: 'Gift Portal',
    subtitle: 'Enter your card number and PIN to select your gift.',
    cardNumber: 'Card Number',
    pin: 'PIN Code',
    cardPlaceholder: 'Enter your card number',
    pinPlaceholder: 'Enter your PIN',
    continue: 'Continue',
    errors: {
      invalid: 'Invalid card number or PIN',
      inactive: 'This voucher is not active',
      redeemed: 'This voucher has already been redeemed',
      expired: 'This voucher has expired',
      invalidCredentials: 'Invalid card or PIN',
      cardUsed: 'This card can no longer be used',
      rateLimited: 'Too many attempts. Please try again later.',
      addressRequired: 'Enter a name and postcode to claim this gift',
      emailRequired: 'Enter a valid email address to claim this gift',
      unknown: 'Something went wrong',
    },
  },
  select: {
    title: 'Welcome',
    subtitle:
      'Pick one of the gifts below. You will receive more information about your gift by email.',
    noGifts: 'No gifts available for this voucher.',
    emailLabel: 'Email address',
    emailPlaceholder: 'email@example.com',
    emailInvalid: 'Enter a valid email address',
    emailBarLabel: 'The confirmation email will be sent to:',
    emailEmpty: 'No email set yet',
    changeEmail: 'change email',
    chooseButton: 'Select',
    chosenButton: 'Selected',
    selectButton: 'Redeem gift card',
    changeEmailTitle: 'Change email',
    changeEmailSubtitle:
      'Update the email address where your gift will be sent.',
    cancel: 'Cancel',
    save: 'Save',
    addressTitle: 'Delivery address',
    addressSubtitle: 'The address we have on file for this gift',
    addressEmptyNotice:
      "We don't have a delivery address for you yet. Please fill it in below.",
    addressSave: 'Save and claim',
    addressNameLabel: 'Full name',
    addressStreetNameLabel: 'Street',
    addressHouseNumberLabel: 'House number',
    addressPostcodeLabel: 'Postcode',
    addressCityLabel: 'City',
    addressCountryLabel: 'Country',
    addressFieldRequired: 'This field is required',
  },
  success: {
    title: 'Gift sent to your email address',
    body: 'Please check your inbox at {email} to find your gift',
    errorTitle: 'Something went wrong',
    tryAgain: 'Try again',
    footerPrivacy: 'Privacy Policy',
    footerTerms: 'Terms of Service',
  },
  email: {
    subject: 'Here is your gift code!',
    codeLabel: 'Your unique code',
    intro: 'Here is your gift code:',
    nameLabel: 'Name',
    poweredBy: 'powered by',
  },
  langSwitch: 'NL',
} as const
